/* PTB v17 — English UI translation layer.
   Scope: visible theme copy only. Does NOT touch inventory, variants, option values,
   gallery matching, swatch colors, product IDs, prices, or cart logic. */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;

  var EXACT = {
    'Langue / Language': 'Language',
    'Aller au contenu': 'Skip to content',
    'Algérie': 'Algeria',
    'Maroc': 'Morocco',
    'Tunisie': 'Tunisia',
    'Égypte': 'Egypt',
    'Turquie': 'Turkey',
    'Sénégal': 'Senegal',
    'RDC': 'DR Congo',
    'Hommes': 'Men',
    'Femmes': 'Women',
    'Enfants': 'Kids',
    'Pulls & Sweats': 'Sweaters & Sweatshirts',
    'Accessoires': 'Accessories',
    'Sacs & Petite Maroquinerie': 'Bags & Small Leather Goods',
    'Bientôt disponible': 'Coming soon',
    'À propos': 'About',
    'Mon compte': 'My account',
    'Recherche': 'Search',
    'Panier': 'Cart',
    'NOUVELLE COLLECTION': 'NEW COLLECTION',
    'Fier de tes racines.': 'Proud of your roots.',
    'Découvrir le shop': 'Shop now',
    'Découvrir le shop →': 'Shop now →',
    'Éditions limitées': 'Limited editions',
    'FIER DE TES RACINES': 'PROUD OF YOUR ROOTS',
    'Choisis ton camp': 'Choose your country',
    'Les pays': 'Countries',
    'Les incontournables': 'Must-haves',
    'Tout voir →': 'View all →',
    'Choisir une collection': 'Choose a collection',
    'DROP HEBDO': 'WEEKLY DROP',
    'Le prochain drop arrive': 'The next drop is coming',
    "Pièces en édition limitée, stock compté. Quand c'est parti, c'est parti.": "Limited-edition pieces, limited stock. Once they're gone, they're gone.",
    'Voir les éditions limitées →': 'View limited editions →',
    "L'esprit PTB": 'THE PTB SPIRIT',
    "PTB c'est la fierté du bled portée haut, avec l'attitude urbaine française. Des pièces pensées pour ceux qui n'oublient jamais d'où ils viennent.": 'PTB is pride in your roots, worn loud with a French urban attitude. Pieces made for those who never forget where they come from.',
    'Notre histoire': 'Our story',
    'Pays': 'Countries',
    'Pièces': 'Pieces',
    'Famille': 'Family',
    'Fraîchement arrivés': 'Just landed',
    'Nouveautés': 'New arrivals',
    'Livraison mondiale': 'Worldwide shipping',
    'Offerte dès 80€': 'Free from €80',
    'Retour sous 14 jours': '14-day returns',
    'Simple et rapide': 'Simple and easy',
    'Paiement sécurisé': 'Secure payment',
    '100% protégé': '100% protected',
    'LIVRAISON OFFERTE DÈS 80€': 'FREE SHIPPING FROM €80',
    '-10% SUR TA PREMIÈRE COMMANDE': '10% OFF YOUR FIRST ORDER',
    'RETOUR SOUS 14 JOURS': '14-DAY RETURNS',
    'NOUVEAUTÉS EXCLUSIVES DZ · MA · TN · FR': 'EXCLUSIVE NEW ARRIVALS DZ · MA · TN · FR',
    'NOUVEAUTÉS EXCLUSIVES DZ · MA · TN · FR · EG · TR · SN · CD': 'EXCLUSIVE NEW ARRIVALS DZ · MA · TN · FR · EG · TR · SN · CD',
    'Rejoins la team PTB': 'Join the PTB team',
    'Rejoins la': 'Join the',
    'Bienvenue dans la team. Check tes mails 📩': 'Welcome to the team. Check your inbox 📩',
    '-10% sur ta première commande + les drops en avant-première.': '10% off your first order + early access to drops.',
    'Streetwear premium inspiré du Maghreb. Fier de tes racines, où que tu sois.': 'Premium streetwear inspired by North Africa. Proud of your roots, wherever you are.',
    'Tous droits réservés.': 'All rights reserved.',
    'NOUVEAU': 'NEW',
    'ÉDITION LIMITÉE': 'LIMITED EDITION',
    '+ Ajout rapide': '+ Quick add',
    'Choisir sa taille →': 'Choose size →',
    'Page introuvable': 'Page not found',
    'Cette page a pris le large. Reviens au bled.': 'This page wandered off. Head back home.',
    "Retour à l'accueil": 'Back to home',
    'Le blog': 'The blog',
    'Ton panier est vide. Il est temps de porter ton bled.': 'Your cart is empty. Time to wear your roots.',
    'Découvrir la boutique →': 'Shop now →',
    '✓ Livraison offerte débloquée': '✓ Free shipping unlocked',
    'Article': 'Item',
    'Quantité': 'Quantity',
    'Note de commande (optionnel)': 'Order note (optional)',
    'Sous-total': 'Subtotal',
    'Taxes et livraison calculées au checkout.': 'Taxes and shipping calculated at checkout.',
    'Mettre à jour': 'Update',
    'Commander →': 'Checkout →',
    'Trier': 'Sort',
    'Filtrer': 'Filter',
    'Réinitialiser': 'Reset',
    "Aucun produit dans cette collection pour l'instant.": 'No products in this collection yet.',
    'PTB Style': 'PTB Style',
    "Besoin d’aide ?": 'Need help?',
    'Utilisez ce formulaire pour toute question concernant un produit, une commande, une livraison, un retour ou la marque PTB Style.': 'Use this form for any question about a product, an order, shipping, a return, or the PTB Style brand.',
    'Pour une commande existante, indiquez votre numéro de commande dans votre message.': 'For an existing order, include your order number in your message.',
    'Email :': 'Email:',
    'Merci. Votre message a bien été envoyé à l’équipe PTB Style.': 'Thank you. Your message has been sent to the PTB Style team.',
    'Nom': 'Name',
    'Numéro de commande': 'Order number',
    '(si concerné)': '(if applicable)',
    'Sujet': 'Subject',
    'Message *': 'Message *',
    'Envoyer le message →': 'Send message →',
    'Explorer': 'Explore',
    'Collections': 'Collections',
    'Photo non disponible pour cette couleur.': 'No photo available for this color.',
    'CHOISIR : COULEUR': 'CHOOSE: COLOR',
    'CHOISIR : TAILLE': 'CHOOSE: SIZE',
    'Ajouter au panier': 'Add to cart',
    'Rupture de stock': 'Sold out',
    'Description': 'Description',
    'Livraison & retours': 'Shipping & returns',
    'Retour sous 14 jours.': '14-day returns.',
    'Paiement 100 % sécurisé.': '100% secure payment.',
    'Matières & entretien': 'Materials & care',
    'Tu aimeras aussi': 'You may also like',
    'Chercher': 'Search',
    'Cherche un produit, un pays, une catégorie…': 'Search for a product, country, category…',
    'Aucun résultat. Essaie « hoodie », « Algérie », « casquette »…': 'No results. Try “hoodie”, “Algeria”, “cap”…',
    'Comment pouvons-nous vous aider ?': 'How can we help you?',
    'Activer mon compte': 'Activate my account',
    'Mot de passe': 'Password',
    'Confirmer': 'Confirm',
    'Activer': 'Activate',
    'Nouvelle adresse': 'New address',
    'Prénom': 'First name',
    'Adresse': 'Address',
    'Ville': 'City',
    'Code postal': 'Postal code',
    'Enregistrer': 'Save',
    'Nouveau mot de passe': 'New password',
    'Carte cadeau': 'Gift card',
    'À utiliser sur': 'Use at',
    'Blanc': 'White',
    'Noir': 'Black',
    'Bleu marine': 'Navy',
    'Bleu Marine': 'Navy',
    'Bleu royal': 'Royal Blue',
    'Gris chiné': 'Heather Grey',
    'Rose bébé': 'Baby Pink',
    'Gris sport': 'Sport Grey',
    'Bordeaux': 'Maroon',
    'Gris chiné foncé': 'Dark Heather',
    'Bleu indigo': 'Indigo Blue',
    'Vert irlandais': 'Irish Green',
    'Bleu ciel': 'Sky Blue',
    'Naturel': 'Natural',
    'Rose clair': 'Light Pink',
    'Bleu clair': 'Light Blue',
    'Gris cendré': 'Ash',
    'Gris foncé': 'Dark Grey',
    'Gris Foncé': 'Dark Grey',
    'Épicéa': 'Spruce',
    'Pierre': 'Stone',
    'Rose': 'Pink',
    'Canneberge': 'Cranberry',
    'Kaki': 'Khaki',
    'Disponibilité': 'Availability',
    'Prix': 'Price',
    'Couleur': 'Color',
    'Taille': 'Size',
    'Marque': 'Brand',
    'Type de produit': 'Product type',
    'Nous contacter': 'Contact us',
    'Une question ? Parlons-en.': "Have a question? Let's talk.",
    'Notre équipe vous répond avec plaisir. Envoyez-nous votre message et nous reviendrons vers vous dès que possible.': 'Our team will be happy to help. Send us a message and we will get back to you as soon as possible.',
    'Téléphone': 'Phone',
    'Écrivez votre message ici...': 'Write your message here...',
    'Merci ! Votre message a bien été envoyé.': 'Thank you! Your message has been sent.'
  };

  var PHRASES = [
    [/À propos/g, 'About'],
    [/Mon compte/g, 'My account'],
    [/Voir tout/g, 'View all'],
    [/Bientôt disponible/g, 'Coming soon'],
    [/bientôt disponible/g, 'coming soon'],
    [/bientôt/g, 'coming soon'],
    [/Sacs & Petite Maroquinerie/g, 'Bags & Small Leather Goods'],
    [/Algérie/g, 'Algeria'],
    [/Maroc/g, 'Morocco'],
    [/Tunisie/g, 'Tunisia'],
    [/ALGÉRIE/g, 'ALGERIA'],
    [/MAROC/g, 'MOROCCO'],
    [/TUNISIE/g, 'TUNISIA'],
    [/Égypte/g, 'Egypt'],
    [/ÉGYPTE/g, 'EGYPT'],
    [/Turquie/g, 'Turkey'],
    [/TURQUIE/g, 'TURKEY'],
    [/Sénégal/g, 'Senegal'],
    [/SÉNÉGAL/g, 'SENEGAL'],
    [/\bRDC\b/g, 'DR Congo'],
    [/Hommes/g, 'Men'],
    [/Femmes/g, 'Women'],
    [/Enfants/g, 'Kids'],
    [/Accessoires/g, 'Accessories'],
    [/Photo précédente/g, 'Previous photo'],
    [/Photo suivante/g, 'Next photo'],
    [/Photo du produit/g, 'Product photo'],
    [/Photo non disponible pour cette couleur/g, 'No photo available for this color'],
    [/Choisir la couleur/g, 'Choose color'],
    [/Choisir la taille/g, 'Choose size'],
    [/Choisir la langue/g, 'Choose language'],
    [/Ouvrir le menu/g, 'Open menu'],
    [/Fermer le menu/g, 'Close menu'],
    [/Navigation principale/g, 'Main navigation'],
    [/Menu mobile/g, 'Mobile menu'],
    [/Recherche/g, 'Search'],
    [/Panier/g, 'Cart'],
    [/Quantité pour/g, 'Quantity for'],
    [/Retirer/g, 'Remove'],
    [/Afficher/g, 'View'],
    [/Compte à rebours du prochain drop/g, 'Countdown to the next drop'],
    [/accueil/g, 'home'],
    [/Tous droits réservés/g, 'All rights reserved'],
    [/Découvrir le shop/g, 'Shop now'],
    [/Retour sous 14 jours/g, '14-day returns'],
    [/Paiement 100 % sécurisé/g, '100% secure payment'],
    [/ton@email\.com/g, 'you@email.com'],
    [/Votre nom/g, 'Your name'],
    [/Votre demande/g, 'Your request'],
    [/Comment pouvons-nous vous aider \?/g, 'How can we help you?'],
    [/Cherche un produit, un pays, une catégorie…/g, 'Search for a product, country, category…'],
    [/vous@exemple\.fr/g, 'you@example.com']
  ];

  function translateString(input) {
    if (typeof input !== 'string' || !input) return input;
    var leading = input.match(/^\s*/)[0];
    var trailing = input.match(/\s*$/)[0];
    var core = input.trim();
    if (!core) return input;

    if (EXACT[core]) return leading + EXACT[core] + trailing;

    var out = core;
    out = out.replace(/^(\d+) produits?$/, function (_, n) { return n + (n === '1' ? ' product' : ' products'); });
    out = out.replace(/^(\d+) résultats?$/, function (_, n) { return n + (n === '1' ? ' result' : ' results'); });
    out = out.replace(/^Plus que$/, 'Only');
    out = out.replace(/^pour la livraison offerte$/, 'left for free shipping');
    out = out.replace(/^Livraison mondiale — offerte dès /, 'Worldwide shipping — free from ');
    out = out.replace(/^Voir tout /, 'View all ');
    out = out.replace(/^Quantité pour /, 'Quantity for ');
    out = out.replace(/^Retirer /, 'Remove ');
    out = out.replace(/^Afficher /, 'View ');
    out = out.replace(/^Collection /, 'Collection ');
    out = out.replace(/^Photo du produit — /, 'Product photo — ');
    out = out.replace(/^vue avant gauche$/, 'front-left view');
    out = out.replace(/^vue avant droite$/, 'front-right view');
    out = out.replace(/^vue de dos$/, 'back view');
    out = out.replace(/^vue de face$/, 'front view');

    PHRASES.forEach(function (pair) { out = out.replace(pair[0], pair[1]); });
    return leading + out + trailing;
  }

  function shouldSkip(node) {
    var parent = node && node.parentElement;
    if (!parent) return true;
    return /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TEMPLATE)$/.test(parent.tagName);
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== 3 || shouldSkip(node)) return;
    var translated = translateString(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  }

  var ATTRS = ['aria-label', 'placeholder', 'title', 'data-label-add', 'data-label-soldout'];
  function translateElement(el) {
    if (!el || el.nodeType !== 1) return;
    ATTRS.forEach(function (attr) {
      if (!el.hasAttribute(attr)) return;
      var current = el.getAttribute(attr);
      var translated = (attr === 'placeholder' && current.trim() === 'Pays') ? 'Country' : translateString(current);
      if (translated !== current) el.setAttribute(attr, translated);
    });
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === 1) translateElement(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) translateTextNode(node);
      else translateElement(node);
    }
  }

  translateTree(document.body);
  document.title = translateString(document.title);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') translateTextNode(mutation.target);
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 3) translateTextNode(node);
        else if (node.nodeType === 1) translateTree(node);
      });
      if (mutation.type === 'attributes') translateElement(mutation.target);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ATTRS
  });
})();
